import script from "./CommitmentPact.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommitmentPact.vue?vue&type=script&setup=true&lang=ts"

import "./CommitmentPact.vue?vue&type=style&index=0&id=8a4d14fa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a4d14fa"]])

export default __exports__